<template>
  <div class="form">
    <h2 :style="{textAlign:'center',color:titlecolor}">获取课程学费报价</h2>
    <div class="title">
      你的姓名
      <span>*</span>
    </div>
    <el-input prefix-icon="el-icon-user" v-model="username" style="width: 100%;margin-bottom:15px;"></el-input>
    <div class="title">
      你的电话
      <span>*</span>
    </div>
    <el-input
      prefix-icon="el-icon-mobile-phone"
      v-model="mobile"
      type="tel"
      style="width: 100%;margin-bottom:20px;"
    ></el-input>
    <el-button
      type="primary"
      :loading="loading"
      style="width:100%"
      :style="{ background: bag, borderColor: bordercolor }"
      @click="show"
    >{{ buttonWords }}</el-button>
    <Vcode :show="isShow" @success="send" @close="close" />
  </div>
</template>

<script>
import { Toast } from "vant";
import Vcode from "vue-puzzle-vcode";
export default {
  data() {
    return {
      username: "",
      mobile: "",
      loading: false,
      buttonWords: this.words,
      bordercolor: this.bordercolor,
      isShow: false
    };
  },
   watch: {
    mobile: "checkMobile"
  },
  components: {
    Vcode
  },
  props: {
    color: {
      type: String,
      default: ""
    },
    bag: {
      type: String,
      default: "#e65c2d"
    },
    words: {
      type: String,
      default: "提交获取学费报价"
    },
    bordercolor: {
      type: String,
      default: "#e65c2d"
    },
    titlecolor: {
      type: String,
      default: "#e65c2d"
    }
  },
  methods: {
     checkMobile() {
      let m = this.mobile;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if (m.length > 10) {
        if (!valid_rule.test(this.mobile)) {
          Toast.fail("手机号码错误");
          return false;
        }
      }
    },
    show() {
      this.buttonWords = "";
      this.loading = true;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      setTimeout(() => {
        this.loading = false;
        this.buttonWords = "获取学费";
      }, 1500);
      if (this.username == "" || this.mobile == "") {
        Toast.fail("请完整填写");
        return false;
      } else if (!valid_rule.test(this.mobile)) {
        Toast.fail("手机号码错误");
        return false;
      } else {
        this.isShow = true;
      }
    },
    close() {
      this.isShow = false;
    },
    send() {
      this.isShow = false;
      this.buttonWords = "";
      this.loading = true;
      this.$axios
        // .get("http://api.cdomick.com/index.php/api/form", {
        .get("http://api.cdomick.com/index.php/form/mianyanginsert", {
          params: {
            name: this.username,
            mobile: this.mobile,
            laiyuan: document.referrer,
            first: window.location.href
          }
        })
        .then(function(response) {
          console.log(response);
          if (response.data.code == 1) {
            Toast.success(response.data.msg);
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            location.reload();
          } else {
            Toast.success("提交成功");
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            location.reload();
          }
        })
        .catch(function(error) {
          console.log(error);
          Toast.success("成功");
          this.loading = false;
          this.buttonWords = "点击报名";
          window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
          location.reload();
        });
    }
  }
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
  text-align: center;
  padding: 10px;
}
/deep/.el-input__icon {
  color: #c9c9c9;
  font-size: 20px;
}
/deep/.el-input__inner {
  border: 1px solid #c9c9c9;
}
/deep/ .ivu-input:hover {
  color: #c9c9c9;
  border: 1px solid #c9c9c9;
}
/deep/ .el-button {
  font-size: 17px;
  font-weight: 600;
}
.title {
  font-size: 13px;
  text-align: left;
  height: 25px;
  width: 100%;
}
.title span {
  color: red;
}
</style>
